import { rem } from 'polished'
import styled from 'styled-components'

import media from '../../utils/media'
import Card from '../shared/Card'

export const MobilityListCard = styled(Card)`
  border-width: 4px;
  color: ${({ theme }) => theme.color.white};
  transition: 0.2s ease;

  &.active {
    background-color: ${({ theme }) => theme.color.white};
    border-color: ${({ theme }) => theme.color.white};
    color: initial;
  }

  ${media.lessThan('xs')`
    border-width: 2px;
  `}
`

export const MobilityListTitle = styled.h3`
  margin-bottom: ${rem(8)};
  font-size: ${rem(18)};
  font-weight: 700;
`

export const MobilityListDesc = styled.p``
